import type { ListActivityResponse } from "../../client-messages/list-activity";

/**
 * The offset of the next activity page, or `undefined` when there is none.
 *
 * Advances by every row the server sent, including rows this build skipped as
 * an unknown kind. Counting only the rows kept would refetch the skipped ones,
 * and a page made only of unknown kinds would request the same offset forever.
 */
export function nextActivityOffset(lastPage: ListActivityResponse, lastPageOffset: number): number | undefined {
  if (lastPage.receivedCount === 0) return undefined;
  const next = lastPageOffset + lastPage.receivedCount;
  return next < lastPage.totalCount ? next : undefined;
}
